import './Experience.css';

const JOBS = [
  {
    company: 'Optisol Business Solutions',
    role: 'Senior Software Engineer',
    date: 'Nov 2022 — Present',
    active: true,
    tags: ['.NET 8', 'Angular 21', 'Azure', 'Supabase', 'MCP'],
    desc: 'Leading full-stack delivery across UK-based enterprise clients — workforce compliance, tax digitisation, and driver management platforms.',
    highlights: [
      'Architected full Angular 21 design system for Bolst Tax MTD platform from scratch',
      'Executed Angular 14→17 & .NET 6→8 upgrade with zero regression in production',
      'Authored complete Cursor Rules enabling consistent AI-assisted development across the team',
    ],
  },
  {
    company: 'Optisol Business Solutions',
    role: 'Software Engineer',
    date: 'Sep 2021 — Oct 2022',
    active: false,
    tags: ['.NET Core 3.1', 'Angular', 'Azure Logic Apps', 'Data Factory'],
    desc: 'Delivered multi-plant procurement platform for MRF — vendor registration, PR–PO workflows, SAP integration, and ETL pipelines.',
    highlights: [
      'Built end-to-end SAP integration via Azure Logic Apps eliminating manual handoffs',
      'Designed Azure Data Factory ETL pipeline migrating millions of rows between SQL Server databases',
      'Led 3-member sub-team delivering PR–PO module on schedule',
    ],
  },
  {
    company: 'GoQuo (TWAI)',
    role: 'Junior → Software Engineer',
    date: 'Jul 2017 — Sep 2021',
    active: false,
    tags: ['C#', 'ASP.NET MVC', 'Vue.js', 'SQL Server', 'AWS S3'],
    desc: 'Built end-to-end flight booking platforms for 4 SE Asian airline clients — Malindo Air, Thai Lion Air, Fly Corporate & Bangkok Air.',
    highlights: [
      'Shipped add-on, payment gateway, flight search & voucher modules supporting thousands of daily transactions',
      'Built interactive Vue.js add-on UI with real-time fare & tax breakdowns',
      'Awarded Best Budding Star for outstanding contribution',
    ],
  },
];

const EDU = [
  { level: 'Postgraduate', degree: 'MCA — Master of Computer Applications', uni: 'Madurai Kamaraj University' },
  { level: 'Undergraduate', degree: 'B.Sc. — Mathematics', uni: 'Vivekananda College' },
];

export default function Experience() {
  return (
    <section id="experience" className="section-wrap">
      <div className="eyebrow-row">
        <div className="eyebrow-line" /><div className="eyebrow-txt">Experience</div><div className="eyebrow-line" />
      </div>

      <div className="timeline">
        <div className="tl-spine" />
        {JOBS.map((j, i) => (
          <div key={j.date} className={`tl-row ${i % 2 === 0 ? 'left' : 'right'}`}>
            {i % 2 === 0 ? (
              <>
                <div className="tl-card card">
                  <div className={`date-pill ${j.active ? 'active' : ''}`}>
                    {j.active && <div className="live-dot" />}{j.date}
                  </div>
                  <div className="tl-company">{j.company}</div>
                  <div className="tl-role">{j.role}</div>
                  <div className="tl-desc">{j.desc}</div>
                  <div className="tl-tags">{j.tags.map(t => <span key={t} className="tag">{t}</span>)}</div>
                  <div className="tl-hls">{j.highlights.map(h => <div key={h} className="hl"><div className="hl-dot" /><span>{h}</span></div>)}</div>
                </div>
                <div className="tl-node"><div className={`tl-dot ${j.active ? 'active' : ''}`} /></div>
                <div className="tl-empty" />
              </>
            ) : (
              <>
                <div className="tl-empty" />
                <div className="tl-node"><div className={`tl-dot ${j.active ? 'active' : ''}`} /></div>
                <div className="tl-card card">
                  <div className="date-pill">{j.date}</div>
                  <div className="tl-company">{j.company}</div>
                  <div className="tl-role">{j.role}</div>
                  <div className="tl-desc">{j.desc}</div>
                  <div className="tl-tags">{j.tags.map(t => <span key={t} className="tag">{t}</span>)}</div>
                  <div className="tl-hls">{j.highlights.map(h => <div key={h} className="hl"><div className="hl-dot" /><span>{h}</span></div>)}</div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="edu-subhead">Education</div>
      <div className="edu-row">
        <div className="card edu-card">
          <div className="edu-level">{EDU[0].level}</div>
          <div className="edu-degree">{EDU[0].degree}</div>
          <div className="edu-uni">{EDU[0].uni}</div>
        </div>
        <div className="edu-icon-wrap"><i className="ti ti-school edu-icon" /></div>
        <div className="card edu-card">
          <div className="edu-level">{EDU[1].level}</div>
          <div className="edu-degree">{EDU[1].degree}</div>
          <div className="edu-uni">{EDU[1].uni}</div>
        </div>
      </div>
    </section>
  );
}
